import React from "react";

const TermsAndConditions = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Terms and Conditions</h1>

      <section>
        <h2 style={styles.h2}>1. Introduction</h2>
        <p style={styles.p}>
          Welcome to our Online Temple Pooja Booking platform. By accessing or
          using this website and its services, you agree to be bound by these
          Terms and Conditions.
        </p>
      </section>

      <section>
        <h2 style={styles.h2}>2. Services Offered</h2>
        <ul style={styles.ul}>
          <li>Book poojas and rituals online</li>
          <li>Make E Kanikka</li>
          <li>Schedule temple services</li>
          <li>Receive booking confirmations and receipts</li>
        </ul>
      </section>

      <section>
        <h2 style={styles.h2}>3. User Responsibilities</h2>
        <ul style={styles.ul}>
          <li>Provide accurate and complete information during booking</li>
          <li>
            Ensure correctness of pooja details (name, star, date, etc.)
          </li>
          <li>Use the platform only for lawful purposes</li>
        </ul>
      </section>

      <section>
        <h2 style={styles.h2}>4. Booking Policy</h2>
        <ul style={styles.ul}>
          <li>
            All pooja bookings are subject to temple availability and schedule
          </li>
          <li>
            Once confirmed, bookings may not be modified or canceled unless
            specified
          </li>
          <li>
            The temple reserves the right to reschedule poojas due to
            unavoidable circumstances
          </li>
        </ul>
      </section>

      <section>
        <h2 style={styles.h2}>5. Payment Terms</h2>
        <ul style={styles.ul}>
          <li>
            All payments must be made through the integrated secure payment
            gateway
          </li>
          <li>We do not store your card or banking details</li>
          <li>
            Payment confirmation will be sent via email/SMS (optional) upon
            successful transaction
          </li>
        </ul>
      </section>

      <section>
        <h2 style={styles.h2}>6. Refund Policy & Cancellation Policy</h2>
        <ul style={styles.ul}>
          <li>Payments once made are generally non-refundable</li>
          <li>
            Refunds, if applicable, will be processed only in exceptional cases
            as per temple policies
          </li>
          <li>Processing time for refunds may vary</li>
        </ul>
      </section>

      <section>
        <h2 style={styles.h2}>7. Service Delivery</h2>
        <ul style={styles.ul}>
          <li>Poojas will be performed as per temple customs and traditions</li>
          <li>
            Prasadam delivery (if applicable) depends on availability and
            location
          </li>
        </ul>
      </section>

      <section>
        <h2 style={styles.h2}>8. Limitation of Liability</h2>
        <ul style={styles.ul}>
          <li>Payment gateway failures or transaction delays</li>
          <li>Incorrect information provided by users</li>
          <li>External technical issues beyond our control</li>
        </ul>
      </section>

      <section>
        <h2 style={styles.h2}>9. Intellectual Property</h2>
        <p style={styles.p}>
          All content on this website (text, images, logos) is the property of
          the temple and may not be reproduced without permission.
        </p>
      </section>

      <section>
        <h2 style={styles.h2}>10. Modification of Terms</h2>
        <p style={styles.p}>
          We reserve the right to update or modify these Terms at any time
          without prior notice.
        </p>
      </section>

      <section>
        <h2 style={styles.h2}>11. Governing Law</h2>
        <p style={styles.p}>
          These Terms shall be governed by and interpreted in accordance with
          the laws of India. Any disputes shall fall under the jurisdiction of
          the local courts.
        </p>
      </section>

      <section>
        <h2 style={styles.h2}>12. Contact Information</h2>
        <p style={styles.p}>
          SANGAMESH VARMA R <br />
Executive Officer - SREE TALIMAHKSHETHRAM <br />
Ph : 8289947686 <br />
talitempleclt@gmail.com <br /><br />

SREE TALI MAHAKSHETHRAM, <br />
TALI DEVASWOM,<br />
Trustee Talidevaswom,<br />
Chalappuram PO,<br />
Kozhikode District, Kerala – 673002
        </p>
      </section>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "900px",
    margin: "0 auto",
    marginTop: "120px",
    padding: "50px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.6",
    backgroundColor: "white",
    
  },
  title: {
    textAlign: "center",
    marginBottom: "30px",
    fontSize: "30px",
    fontWeight: "600",
    borderBottom: "2px solid black",
  },
  h2:{
    color: "black",
    fontSize: "24px",
    marginTop: "20px",
    fontWeight: "600",
    marginTop: "40px",
  },
  p: {
    fontSize: "15px",
    lineHeight: "1.6",
  },
  ul: {
    fontSize: "15px",
    paddingLeft: "33px",
    color: "black",
    listStyleType: "disc",
  },
};

export default TermsAndConditions;